module.exports = __webpack_public_path__ + "static/media/bionic.9019effe.jpeg";